import { render, staticRenderFns } from "./DatasetTable.vue?vue&type=template&id=0412d93d"
import script from "./DatasetTable.vue?vue&type=script&lang=js"
export * from "./DatasetTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports